__turbopack_context__.v({
  "blue10": "_nS6La_blue10",
  "blue20": "_nS6La_blue20",
  "blue30": "_nS6La_blue30",
  "breachLogo": "_nS6La_breachLogo",
  "green10": "_nS6La_green10",
  "green20": "_nS6La_green20",
  "green30": "_nS6La_green30",
  "green40": "_nS6La_green40",
  "green50": "_nS6La_green50",
  "orange10": "_nS6La_orange10",
  "orange20": "_nS6La_orange20",
  "orange30": "_nS6La_orange30",
  "pink10": "_nS6La_pink10",
  "pink20": "_nS6La_pink20",
  "purple05": "_nS6La_purple05",
  "purple10": "_nS6La_purple10",
  "purple30": "_nS6La_purple30",
  "purple40": "_nS6La_purple40",
  "red10": "_nS6La_red10",
  "red20": "_nS6La_red20",
  "red30": "_nS6La_red30",
  "violet10": "_nS6La_violet10",
  "violet20": "_nS6La_violet20",
  "violet30": "_nS6La_violet30",
});
